import { render, staticRenderFns } from "./ehc-updates-log-details.vue?vue&type=template&id=0c5d70fd"
import script from "./ehc-updates-log-details.vue?vue&type=script&lang=js"
export * from "./ehc-updates-log-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports